import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SimpleLink from "../../utils/SimpleLink/SimpleLink";
import css from "./VisitPage.module.css";

export default function VisitPage() {
  return (
    <>
      <div className={css["header-small"]}>
        <div className={css["header-caption"]}>
          <h1 className="display-3 fw-normal">Prepara la visita</h1>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-4 p-md-5 p-3 text-center">
            <FontAwesomeIcon icon={"clock"} className="fa-2x p-3" />
            <h3>Orari di apertura</h3>
            <br />
            <p className="text-muted">
              Il museo è attualmente in ristrutturazione e dunque non
              visitabile. La riapertura è prevista per l'autunno 2023.
            </p>
            {/* <p className="lead">MAR. E GIO. 10.00-13.00</p>
            <p className="lead">MER. E VEN. 15.00-18.00</p>
            <p className="lead"> SAB. DOM. FESTIVI 10.00-18.00</p>
            <hr />
            <small className="text-muted">
              Si consiglia di verificare la corrispondenza degli orari di
              apertura contattando direttamente la struttura. Tel: +39 0736
              277558
            </small> */}
          </div>
          <div className="col-12 col-md-4 p-md-5 p-3 text-center">
            <FontAwesomeIcon icon={"location-dot"} className="fa-2x p-3" />
            <h3>Dove siamo</h3>
            <br />
            <p className="lead">
              Via della Cartiera, 1 <br />
              63100 Ascoli Piceno
            </p>
            <hr />
            <SimpleLink
              href={"https://goo.gl/maps/mVX29HgMCZxyu1VLA"}
              target="_blank"
            >
              Indicazioni stradali
            </SimpleLink>
            <br />
          </div>
          <div className="col-12 col-md-4 p-md-5 p-3 text-center">
            <FontAwesomeIcon icon={"ticket"} className="fa-2x p-3" />
            <h3>Prezzo biglietti</h3>
            {/* <br />
            <p className="lead fw-normal">Intero: € 5,00</p>
            <p>Ridotto: € 3,00</p>
            <p>Scuole: € 2,00</p>
            <hr />
            <small className="text-muted">
              Per i gruppi superiori alle 10 unità è obbligatoria la
              segnalazione del giorno e dell'orario di visita all'indirizzo
              email ???
            </small> */}
          </div>
        </div>
        <hr />
        <div className="row py-5">
          <div className="col-lg-3">
            <h3>Come raggiungerci</h3>
          </div>
          <div className="col-12 col-lg-3">
            <h4>Indirizzo</h4>
            <p>
              <SimpleLink
                href={"https://goo.gl/maps/mVX29HgMCZxyu1VLA"}
                target="_blank"
              >
                Via della Cartiera, 1 <br />
                63100 Ascoli Piceno
              </SimpleLink>
            </p>
            <h4>Viaggio in automobile</h4>
            <ul>
              <li>Roma: 2h30m</li>
              <li>Bologna: 3h</li>
              <li>Firenze: 3h30m</li>
              <li>Bari: 3h45m</li>
              <li>Napoli: 3h45m</li>
              <li>Pisa: 4h15m</li>
              <li>Milano: 5h</li>
            </ul>
          </div>
          <div className="col-12 col-lg-6">
            <div className="ratio ratio-4x3">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m13!1m8!1m3!1d446.0979825194434!2d13.569834!3d42.849457!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNDLCsDUwJzU4LjEiTiAxM8KwMzQnMTEuNSJF!5e1!3m2!1sit!2sit!4v1686902977414!5m2!1sit!2sit"
                width="600"
                height="450"
                style={{ border: 0 }}
                allowFullScreen={false}
                loading="lazy"
                referrerPolicy={"no-referrer-when-downgrade"}
                title="Mappa"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
